const namespaced = true;

const defaultState = () => {
  return {
    locations: [],
    loading: false,
    selectedCompany: {},
    add: false,
    edit: false,
    selectedLocation: {},
    confirm: false,
  };
};

const state = defaultState();
const actions = {};
const mutations = {
  resetState(state) {
    Object.assign(state, defaultState());
  },
  SET_CHECK_EDIT_COMPANY(state, val) {
    if (state.selectedCompany.id === val.id) {
      state.selectedCompany = val;
    }
  },
  SET_CONFIRM(state, confirm) {
    state.confirm = confirm;
  },
  SET_ADD(state, add) {
    state.add = add;
  },
  SET_EDIT(state, edit) {
    state.edit = edit;
  },
  ADD_LOCATION(state, location) {
    state.locations = [...state.locations, location];
  },
  SELECTED_LOCATION(state, selectedLocation) {
    state.selectedLocation = selectedLocation;
  },
  REMOVE_LOCATION(state, location) {
    const index = state.locations
      .map((location) => location.id)
      .indexOf(location.id);
    if (index !== -1) {
      state.locations.splice(index, 1);
    }
  },
  EDIT_LOCATION(state, location) {
    const index = state.locations
      .map((location) => location.id)
      .indexOf(location.id);
    if (index !== -1) {
      state.locations.splice(index, 1, location);
    }
  },
  SET_SELECTED_COMPANY(state, selectedCompany) {
    state.selectedCompany = selectedCompany;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_LOCATIONS(state, locations) {
    state.locations = locations;
  },
};
const getters = {};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
